/**
 * Central asset registry — single source of truth for all branding and key images.
 *
 * To update an asset across the entire app, simply replace the file at the
 * path listed next to each import. No code changes required.
 */

// === Branding ===
// Replace: src/assets/branding/logo.svg
import logo from "@/assets/branding/logo.svg";

// Replace: src/assets/branding/logo-light.svg
import logoLight from "@/assets/branding/logo-light.svg";

// Replace: src/assets/branding/logo-icon.png
import logoIcon from "@/assets/branding/logo-icon.png";

// Replace: src/assets/branding/logo-desktop-dark.svg
import logoDesktop from "@/assets/branding/logo-desktop-dark.svg";

// === Content images ===
// Replace: src/assets/images/hero-image.png (served as WebP for ~93% size reduction)
import heroImage from "@/assets/images/hero-image.webp";

// Replace: src/assets/images/section-image.webp  (reserved for future use)
import sectionImage from "@/assets/images/section-image.webp";

export const siteAssets = {
  /** Primary SVG logo (dark variant) */
  logo,
  /** SVG logo for dark backgrounds */
  logoLight,
  /** Compact PNG icon for sidebars, headers, app shell */
  logoIcon,
  /** Full desktop SVG logo for dashboard sidebar */
  logoDesktop,
  /** Main hero/landing visual */
  heroImage,
  /** Secondary content image slot (future use) */
  sectionImage,
} as const;

export default siteAssets;
